// src/pages/admin/AdminDashboard.js
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import { db } from "../../lib/firebase";
import { collection, getDocs, orderBy, query, deleteDoc, doc } from "firebase/firestore";

const pill = { textDecoration:"none", background:"#ffd13b", color:"#0b0f14", padding:"10px 14px", borderRadius:999, fontWeight:800 };
const pillBtn = { ...pill, border:"none", cursor:"pointer" };

export default function AdminDashboard(){
  const { logout } = useAuth();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  async function load() {
    setLoading(true);
    const q = query(collection(db, "posts"), orderBy("publishedAt", "desc"));
    const snap = await getDocs(q);
    setPosts(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    setLoading(false);
  }

  useEffect(() => { load(); }, []);

  async function onDelete(slug) {
    if (!window.confirm("Delete this post permanently?")) return;
    await deleteDoc(doc(db, "posts", slug));
    // refresh list
    setPosts(prev => prev.filter(p => (p.slug || p.id) !== slug));
  }

  return (
    <div style={{ maxWidth: 960, margin:"90px auto", padding:"0 18px", color:"#e9eef5" }}>
      <h1>Admin</h1>
      <div style={{ display:"flex", gap:12, margin:"12px 0 24px" }}>
        <Link to="/admin/new" style={pill}>+ New Post</Link>
        <button onClick={logout} style={pillBtn}>Logout</button>
      </div>

      {loading ? <p>Loading…</p> : (
        <div style={{ display:"grid", gap:12 }}>
          {posts.length === 0 && <p>No posts yet.</p>}
          {posts.map(p => {
            const slug = p.slug || p.id;
            <Link to={`/admin/edit/${slug}`}>Edit</Link>
            const dateStr = p.publishedAt?.toDate?.().toLocaleString?.() || "";
            return (
              <div key={slug} style={{
                background:"rgba(14,18,24,.72)",
                border:"1px solid rgba(255,209,59,.25)",
                borderRadius:16, padding:14,
                display:"grid", gridTemplateColumns:"1fr auto", alignItems:"center", gap:12
              }}>
                <div>
                  <div style={{ fontWeight:800 }}>{p.title}</div>
                  <div style={{ opacity:.8, fontSize:12 }}>{slug} · {dateStr}</div>
                </div>
                <div style={{ display:"flex", gap:8 }}>
                  <Link to={`/admin/edit/${slug}`} style={{ ...pill, padding:"8px 12px" }}>Edit</Link>
                  <button onClick={() => onDelete(slug)} style={{ ...pillBtn, background:"transparent", color:"#ffd13b", border:"1px solid rgba(255,209,59,.4)" }}>
                    Delete
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
